import React from 'react'
import cn from 'classnames'

import st from './index.scss'

export default function DialogBackground(Dom) {
  class BgClass extends React.Component {
    render() {
      const { dialogClassName } = this.props

      return <div className={cn(st['box'], dialogClassName)}>
        <Dom {...this.props} />
      </div>
    }
  }
  return BgClass
}
